<dt-modal-content [showFooter]="false" [contentPadding]="false" size="small" (closeClick)="dialogRef.close()">
  <ng-template #title i18n>Navi-Einstellungen</ng-template>
  <ng-template #content>
    <div class="section">
      <div class="title" i18n>Assistent</div>
      <mat-form-field>
        <mat-label i18n>Assistenten beim Start öffnen</mat-label>
        <mat-select [(ngModel)]="appSettings.helpLaunchMode">
          <mat-option value="restore-last" i18n>Letzten Zustand wiederherstellen</mat-option>
          <mat-option value="open" i18n>Ja</mat-option>
          <mat-option value="closed" i18n>Nein</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-divider></mat-divider>
    <div class="section">
      <div class="title" i18n>Sicherheitsabfragen</div>
      @if (nightly) {
        <mat-slide-toggle [(ngModel)]="appSettings.showNightlyWarning" labelPosition="before" i18n
          >Warnung vor Nightly-Version</mat-slide-toggle
        >
      }
      <mat-slide-toggle [(ngModel)]="appSettings.skipSubstepWarning" labelPosition="before" i18n>Teilschritt überspringen</mat-slide-toggle>
      <mat-slide-toggle [(ngModel)]="appSettings.overwriteOutcomeConfirmation" labelPosition="before" i18n
        >Ausprägung durch Drag &amp; Drop überschreiben</mat-slide-toggle
      >
    </div>
    <mat-divider></mat-divider>
    <div class="section">
      <div class="title" i18n>Optionale Features</div>
      <mat-slide-toggle [(ngModel)]="appSettings.showSendButtons" labelPosition="before" i18n
        >Möglichkeit Ziele &amp; Alternativen an andere geöffnete Navi Instanzen zu übertragen</mat-slide-toggle
      >
      @if (isPrivilegedUser$ | async) {
        <mat-slide-toggle [(ngModel)]="appSettings.measureTimeSpent" labelPosition="before" i18n
          >Verbrachte Zeit pro Teilschritt erfassen</mat-slide-toggle
        >
      }
    </div>
  </ng-template>
</dt-modal-content>
